import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const notificationApiService = createApi({
  reducerPath: "notificationApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getCourseNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `notification/course/status${query}`,
          method: "GET",
        };
      },
    }),
    getCourseExpiryNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `notification/course/expiry${query}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetCourseNotificationsQuery,
  useGetCourseExpiryNotificationsQuery,
} = notificationApiService;
